export const UTM_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];



// WEBPACK FOOTER //
// ../utilities/utm/utm.constants.js